<template>
    <section class="page">
      <main>
        <div class="header">
          <div class="headerright"> 
             
          </div>
          <strong>在线申请管理</strong>
        </div>
        <div class="pagemain">
          <div class="tblbox">
            <div class="searchbox">
              <a-form layout="inline">
                <a-form-item label="公司名称">
                  <a-input placeholder="请输入" v-model:value="requestData.companyName" />
                </a-form-item>
                <a-form-item label="成立时间">
                  <a-range-picker v-model:value="requestData.establishmentTime" />
                </a-form-item>
                <a-form-item label="联系人">
                  <a-input placeholder="请输入" v-model:value="requestData.contact" />
                </a-form-item>
                <a-form-item>
                  <a-button type="primary" @click="search">查询</a-button>
                </a-form-item>
              </a-form>
            </div>
            <a-table size="small" :dataSource="applyList" :columns="columns" :scroll="{ y: 'calc(100vh - 280px)' }" :pagination="pagination" @change="handleTableChange" :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)">
              <template #bodyCell="{ column, record, index }">
                <template v-if="column.key === 'sn'">
                  {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                </template>
                <template v-if="column.key === 'operation'">
                  <a-dropdown placement="bottomRight">
                    <a-space>
                      <a href="javascript:;" @click.prevent="viewDetails(record.id)">详情</a>
                      <a-popconfirm placement="left" title="确认删除?" ok-text="确认" cancel-text="取消" @confirm="removeApply(record)">
                        <a title="删除" href="javascript:;" style="margin-left: 5px;">删除</a>
                      </a-popconfirm>
                    </a-space>
                  </a-dropdown>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </main>
      <!-- 详情弹窗 -->
    <a-modal
      v-model:visible="detailVisible"
      title="详情信息"
      width="60%"
      :footer="null"
      destroy-on-close
    >
      <a-form :labelCol="labelCol" :layout="'vertical'">
        <a-form-item label="公司名称">
          <span>{{ detailData.companyName }}</span>
        </a-form-item>
        <a-form-item label="成立时间">
          <span>{{ detailData.establishmentTime }}</span>
        </a-form-item>
        <a-form-item label="联系人">
          <span>{{ detailData.contact }}</span>
        </a-form-item>
        <a-form-item label="注册资本">
          <span>{{ detailData.registeredCapital }}</span>
        </a-form-item>
        <a-form-item label="联系电话">
          <span>{{ detailData.phone }}</span>
        </a-form-item>
        <a-form-item label="邮箱">
          <span>{{ detailData.email }}</span>
        </a-form-item>
        <a-form-item label="地址">
          <span>{{ detailData.address }}</span>
        </a-form-item>
        <a-form-item label="主营业务">
          <span>{{ detailData.mainBusiness }}</span>
        </a-form-item>
        <a-form-item label="公司简介">
          <span>{{ detailData.companyProfile }}</span>
        </a-form-item>
      </a-form>
    </a-modal>
    </section>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted } from 'vue';
  import { FileAddOutlined } from '@ant-design/icons-vue';
  import { message, Modal } from 'ant-design-vue';
  import dayjs from 'dayjs';
  import axios from 'axios';
  import { Uris } from "@/shared/const";
  
  const visible = ref(false);
  const form = reactive({
    companyName: '',
    establishmentTime: null,
    registeredCapital: '',
    contact: '',
    phone: '',
    email: '',
    address: '',
    mainBusiness: '',
    companyProfile: '',
    message: '',
  });
  
  const requestData = reactive({
    companyName: '',
    establishmentTime: null,
    contact: '',
  }); 
  
  const applyList = ref([]);
  const pagination = reactive({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  
  const columns = [
    {
      title: '序号',
      dataIndex: 'sn',
      key: 'sn',
      width: 50,
      align: 'center',
    },
    {
      title: '公司名称',
      dataIndex: 'companyName',
      width: 150,
      key: 'companyName',
    },
    {
      title: '成立时间',
      dataIndex: 'establishmentTime',
      key: 'establishmentTime',
      width: 150,
    },
    {
      title: '联系人',
      dataIndex: 'contact',
      key: 'contact',
      width: 100,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 150,
      align: 'center',
    },
  ];
  
  const fetchApplyList = async () => {
    try {
      const searchModel = {
      companyName: "",
      contact: "",
      startTime: null,
      endTime: null,
      pageIndex: pagination.current,
      pageSize: pagination.pageSize
    };
    searchModel.companyName = requestData.companyName;
    searchModel.contact = requestData.contact;
    if (requestData.establishmentTime != null) {
      searchModel.startTime = dayjs(requestData.establishmentTime[0]).format('YYYY-MM-DD');
      searchModel.endTime = dayjs(requestData.establishmentTime[1]).format('YYYY-MM-DD');
    } else { 
        
      searchModel.startTime = null;
      searchModel.endTime = null;
    }
      const { data } = await axios.get(Uris.OnlineApplyList, {
        params: searchModel,
      });
      // applyList.value = data.list;
      // 格式化 establishmentTime 字段
    applyList.value = data.list.map(item => ({
      ...item,
      establishmentTime: dayjs(item.establishmentTime).format('YYYY-MM-DD'), // 格式化为 YYYY-MM-DD
    }));
      pagination.total = data.totalCount;
    } catch (err) {
      message.error('加载列表失败');
    }
  };
  
  const handleTableChange = (paginationInfo) => {
    pagination.current = paginationInfo.current; // 更新当前页码
    pagination.pageSize = paginationInfo.pageSize; // 更新每页条数
    fetchApplyList();
  };
   
  const detailVisible = ref(false); // 控制详情弹窗的显示
  const detailData = reactive({
  companyName: '',
  establishmentTime: '',
  registeredCapital: '',
  contact: '',
  phone: '',
  email: '',
  address: '',
  mainBusiness: '',
  companyProfile: '',
});

const fetchDetailData = async (id) => {
  try {
    const { data } = await axios.get(Uris.OnlineApplyDetail+`?id=${id}`);
    // 格式化 establishmentTime 字段
    data.establishmentTime = dayjs(data.establishmentTime).format('YYYY-MM-DD');
    Object.assign(detailData, data);
    detailVisible.value = true;
  } catch (err) {
    message.error('加载详情失败');
  }
};

const viewDetails = (id) => {
  fetchDetailData(id); // 调用接口获取详情数据
}; 
  
  const removeApply = async (record) => {
    try {
      await axios.get(Uris.OnlineApplyDelete + `?id=${record.id}`);
      message.success('删除成功');
      // 判断当前页是否为最后一条数据
      const currentPageLastItem = applyList.value.length == 1;
      if (currentPageLastItem && pagination.current > 1) {
      // 如果当前页只有一条数据并且不是第一页，则跳转到上一页
      pagination.current -= 1;
}
      fetchApplyList();
    } catch (err) {
      message.error('删除失败');
    }
  };
  
  const search = () => {
    fetchApplyList();
  };
  
  onMounted(() => {
    fetchApplyList();
  });
  
  const labelCol = {
    style: {
      width: '120px',
    },
  };
  </script>
  
  <style lang="less">
  .full-modal {
    .ant-modal {
      max-width: 100%;
      top: 0;
      padding-bottom: 0;
      margin: 0;
    }
  
    .ant-modal-content {
      display: flex;
      flex-direction: column;
      height: calc(100vh);
    }
  
    .ant-modal-body {
      flex: 1;
    }
  }
  </style>
  